export default __webpack_public_path__ + "static/media/default-avatar-lg.ffb2b3ff.jpg";